import React, { useState, useEffect } from "react";

import {
  Box,
  Container,
  Typography,
  Divider,
  ToggleButton,
  ToggleButtonGroup,
  Grid,
  Alert,
  Button,
  TextField,
} from "@mui/material";

import VivaComponent from "../components/viva.component";
import ChangeVatUtilComponent from "../components/changeVatUtil";

import axiosClient from "../axiosClient";
import { useStateContext } from "../context/ContextProvider";

const SystemSettingsScreen = () => {
  const [mode, setMode] = useState("simple");
  const [language, setLanguage] = useState("");
  const [defaultPrice, setDefaultPrice] = useState("");
  const [accountantEmail, setAccountantEmail] = useState("");
  const [footerNote, setFooterNote] = useState("");
  const [details, setDetails] = useState();
  const [maxPrice, setMaxPrice] = useState();
  const [syncHours, setSyncHours] = useState();
  const [printerSize, setPrinterSize] = useState();

  const [message, setMessage] = useState();

  const { store } = useStateContext();

  useEffect(() => {
    const correctStoreName = JSON.parse(store).name.replace(/[^a-zA-Z]/g, "");
    const databaseStoreName = `DB301_${
      JSON.parse(store).id
    }_${correctStoreName}`;

    axiosClient
      .get(`storeDetails/${databaseStoreName}`)
      .then((response) => {
        setDetails(JSON.parse(response.data.data[0].viva_details));
        setMode(response.data.data[0].mode);
        setDefaultPrice(response.data.data[0].default_price);
        setAccountantEmail(response.data.data[0].accountant_email);
        setFooterNote(response.data.data[0].recipe_footer);
        setLanguage(response.data.data[0].language);
        setMaxPrice(response.data.data[0].maxPrice);
        setSyncHours(response.data.data[0].syncHours);
        setPrinterSize(response.data.data[0].printer_size);
      })
      .catch((err) => console.log(err));
  }, [store]);

  return (
    <Container container style={{ margin: 2 }}>
      <Typography variant="h5" gutterBottom>
        System Settings
      </Typography>
      {message && (
        <Alert severity="success" sx={{ marginBottom: 2 }}>
          {message}
        </Alert>
      )}
      <Divider />
      {/* <Box sx={{ margin: 4 }} />
      <Typography variant="h6" gutterBottom>
        VIVA Settings
      </Typography>
      <VivaComponent details={details} setMessage={setMessage} />
      <Box sx={{ margin: 2 }} />
      <Divider /> */}
      <Box sx={{ margin: 4 }} />
      <Typography variant="h6" gutterBottom>
        Mobile app mode
      </Typography>
      <ToggleButtonGroup
        color="primary"
        exclusive
        onChange={(e) => {
          const correctStoreName = JSON.parse(store).name.replace(
            /[^a-zA-Z]/g,
            ""
          );
          const databaseStoreName = `DB301_${
            JSON.parse(store).id
          }_${correctStoreName}`;

          const payload = {
            shopName: databaseStoreName,
            mode: e.target.value,
          };
          axiosClient
            .patch("storeDetails/mode/update", payload)
            .then((response) => setMessage(response.data.message))
            .catch((err) => console.log(err));
          setMode(e.target.value);
        }}
        aria-label="Mode"
        value={mode}
      >
        <ToggleButton value="simple">Simple</ToggleButton>
        <ToggleButton value="advance">Advance</ToggleButton>
        <ToggleButton value="beach">Beach</ToggleButton>
      </ToggleButtonGroup>
      <Box sx={{ margin: 2 }} />
      <Divider />
      <Box sx={{ margin: 4 }} />
      <Typography variant="h6" gutterBottom>
        Mobile app language
      </Typography>
      <ToggleButtonGroup
        color="primary"
        exclusive
        onChange={(e) => {
          const correctStoreName = JSON.parse(store).name.replace(
            /[^a-zA-Z]/g,
            ""
          );
          const databaseStoreName = `DB301_${
            JSON.parse(store).id
          }_${correctStoreName}`;

          const payload = {
            shopName: databaseStoreName,
            language: e.target.value,
          };
          axiosClient
            .patch("storeDetails/language/update", payload)
            .then((response) => setMessage(response.data.message))
            .catch((err) => console.log(err));
          setLanguage(e.target.value);
        }}
        aria-label="Language"
        value={language}
      >
        <ToggleButton value="greek">Greek</ToggleButton>
        <ToggleButton value="english">English</ToggleButton>
        {/* <ToggleButton value="russian">Russian</ToggleButton> */}
      </ToggleButtonGroup>
      <Box sx={{ margin: 2 }} />
      <Divider />
      <Box sx={{ margin: 4 }} />
      <Typography variant="h6" gutterBottom>
        Default price
      </Typography>
      <ToggleButtonGroup
        color="primary"
        exclusive
        onChange={(e) => {
          const correctStoreName = JSON.parse(store).name.replace(
            /[^a-zA-Z]/g,
            ""
          );
          const databaseStoreName = `DB301_${
            JSON.parse(store).id
          }_${correctStoreName}`;

          const payload = {
            shopName: databaseStoreName,
            default_price: e.target.value,
          };
          axiosClient
            .patch("storeDetails/price/update", payload)
            .then((response) => setMessage(response.data.message))
            .catch((err) => console.log(err));
          setDefaultPrice(e.target.value);
        }}
        aria-label="price"
        value={defaultPrice}
      >
        <ToggleButton value="Seat in">Seat-in</ToggleButton>
        <ToggleButton value="Take away">Take away</ToggleButton>
        <ToggleButton value="Not applicable">Not applicable</ToggleButton>
      </ToggleButtonGroup>
      <Box sx={{ margin: 2 }} />
      <Divider />
      <Box sx={{ margin: 4 }} />
      <Typography variant="h6" gutterBottom>
        Accountant email
      </Typography>
      <Grid item xs={12} sm={3} md={3} lg={3}>
        <TextField
          sx={{ width: "75%" }}
          label="Accountant email"
          name="accountant_email"
          value={accountantEmail}
          onChange={(e) => {
            setAccountantEmail(e.target.value);
          }}
        />
        <Grid container xs={12} justifyContent="flex-end">
          <Button
            type="submit"
            variant="contained"
            color="success"
            onClick={() => {
              const correctStoreName = JSON.parse(store).name.replace(
                /[^a-zA-Z]/g,
                ""
              );
              const databaseStoreName = `DB301_${
                JSON.parse(store).id
              }_${correctStoreName}`;

              const payload = {
                shopName: databaseStoreName,
                accountant_email: accountantEmail,
              };
              axiosClient
                .patch("storeDetails/email/update", payload)
                .then((response) => setMessage(response.data.message))
                .catch((err) => console.log(err));
            }}
          >
            Change
          </Button>
        </Grid>
      </Grid>
      <Box sx={{ margin: 2 }} />
      <Divider />
      <Box sx={{ margin: 4 }} />
      <Typography variant="h6" gutterBottom>
        Recipe footer note
      </Typography>
      <Grid item xs={12} sm={3} md={3} lg={3}>
        <TextField
          id="outlined-multiline-static"
          label="Enter text"
          multiline
          rows={4}
          value={footerNote}
          onChange={(e) => {
            const inputValue = e.target.value;
            const lines = inputValue.split("\n");
            const sanitizedLines = lines.map((line) => line.slice(0, 42));
            const newValue = sanitizedLines.join("\n");
            setFooterNote(newValue);
          }}
          variant="outlined"
          fullWidth
          inputProps={{
            maxLength: 42 * 4 + 3, // 42 characters per line multiplied by 4 lines
          }}
        />
        <Grid container xs={12} justifyContent="flex-end">
          <Button
            type="submit"
            variant="contained"
            color="success"
            onClick={() => {
              const correctStoreName = JSON.parse(store).name.replace(
                /[^a-zA-Z]/g,
                ""
              );
              const databaseStoreName = `DB301_${
                JSON.parse(store).id
              }_${correctStoreName}`;

              const payload = {
                shopName: databaseStoreName,
                recipe_footer: footerNote,
              };
              axiosClient
                .patch("storeDetails/footer/update", payload)
                .then((response) => setMessage(response.data.message))
                .catch((err) => console.log(err));
            }}
          >
            Change
          </Button>
        </Grid>
      </Grid>
      <Box sx={{ margin: 2 }} />
      <Divider />
      <Box sx={{ margin: 4 }} />
      <ChangeVatUtilComponent setMessage={setMessage} />
      <Box sx={{ margin: 2 }} />
      <Divider />
      <Box sx={{ margin: 4 }} />
      <Typography variant="h6" gutterBottom>
        Order max price
      </Typography>
      <Grid item xs={12} sm={3} md={3} lg={3}>
        <TextField
          name="maxValue"
          label="Max value"
          fullWidth
          value={maxPrice}
          onChange={(e) => {
            const maxP = parseFloat(e.target.value) || null;
            setMaxPrice(maxP);
          }}
        />
        <Grid container xs={12} justifyContent="flex-end">
          <Button
            type="submit"
            variant="contained"
            color="success"
            onClick={() => {
              const correctStoreName = JSON.parse(store).name.replace(
                /[^a-zA-Z]/g,
                ""
              );
              const databaseStoreName = `DB301_${
                JSON.parse(store).id
              }_${correctStoreName}`;

              const payload = {
                shopName: databaseStoreName,
                maxPrice: maxPrice,
              };
              axiosClient
                .patch("storeDetails/maxPrice/update", payload)
                .then((response) => setMessage(response.data.message))
                .catch((err) => console.log(err));
            }}
          >
            Change
          </Button>
        </Grid>
      </Grid>
      <Box sx={{ margin: 2 }} />
      <Divider />
      <Box sx={{ margin: 4 }} />
      <Typography variant="h6" gutterBottom>
        Synhronization (hours)
      </Typography>
      <Grid item xs={12} sm={3} md={3} lg={3}>
        <TextField
          name="syncHours"
          label="Synchronisation (hours)"
          InputLabelProps={{ shrink: true }}
          fullWidth
          value={syncHours}
          onChange={(e) => {
            setSyncHours(e.target.value);
          }}
        />
        <Grid container xs={12} justifyContent="flex-end">
          <Button
            type="submit"
            variant="contained"
            color="success"
            onClick={() => {
              const correctStoreName = JSON.parse(store).name.replace(
                /[^a-zA-Z]/g,
                ""
              );
              const databaseStoreName = `DB301_${
                JSON.parse(store).id
              }_${correctStoreName}`;

              const payload = {
                shopName: databaseStoreName,
                syncHours: syncHours,
              };
              axiosClient
                .patch("storeDetails/syncHours/update", payload)
                .then((response) => setMessage(response.data.message))
                .catch((err) => console.log(err));
            }}
          >
            Change
          </Button>
        </Grid>
      </Grid>
      <Box sx={{ margin: 2 }} />
      <Divider />
      <Box sx={{ margin: 4 }} />
      <Typography variant="h6" gutterBottom>
        Mobile app printer size
      </Typography>
      <ToggleButtonGroup
        color="primary"
        exclusive
        onChange={(e) => {
          const correctStoreName = JSON.parse(store).name.replace(
            /[^a-zA-Z]/g,
            ""
          );
          const databaseStoreName = `DB301_${
            JSON.parse(store).id
          }_${correctStoreName}`;

          const payload = {
            shopName: databaseStoreName,
            printer_size: e.target.value,
          };
          axiosClient
            .patch("storeDetails/printerSize/update", payload)
            .then((response) => setMessage(response.data.message))
            .catch((err) => console.log(err));
          setPrinterSize(e.target.value);
        }}
        aria-label="Printer size"
        value={printerSize}
      >
        <ToggleButton value="58">58mm</ToggleButton>
        <ToggleButton value="79">79mm</ToggleButton>
      </ToggleButtonGroup>
      <Box sx={{ margin: 2 }} />
      <Divider />
      <Box sx={{ margin: 4 }} />
    </Container>
  );
};

export default SystemSettingsScreen;
